/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable @typescript-eslint/no-unused-vars */
import * as React from 'react';
import type { SVGProps } from 'react';
const SingleSizeIllustrationFeedbackDefaultNeutral = (
  props: SVGProps<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 42 42"
    data-xds="SingleSizeIllustrationFeedbackDefaultNeutral"
    role="presentation"
    {...props}
  >
    <g clipPath="url(#clip0_10198_366)">
      <path
        fill="var(--xdlColorIllustrationOutlineSecondary)"
        d="M21 42c11.598 0 21-9.402 21-21S32.598 0 21 0 0 9.402 0 21s9.402 21 21 21"
      />
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M14.454 15.887c-2.24 0-4.247.992-5.611 2.56a7.4 7.4 0 0 0 5.61 2.559 7.41 7.41 0 0 0 5.612-2.56 7.42 7.42 0 0 0-5.611-2.56M27.544 15.887c-2.24 0-4.247.991-5.611 2.559a7.4 7.4 0 0 0 5.61 2.56c2.24 0 4.248-.992 5.612-2.56a7.42 7.42 0 0 0-5.611-2.56"
        clipRule="evenodd"
      />
      <path fill="#1D2124" d="M23.83 25.98h-5.95v-1h5.95z" />
      <path
        fill="#1D2124"
        fillRule="evenodd"
        d="M14.55 15.31c2.39 0 4.53 1.06 5.99 2.73l.29.33-.29.33a7.92 7.92 0 0 1-5.99 2.73l-.455-.013a7.92 7.92 0 0 1-5.545-2.718l-.28-.33.29-.329a7.94 7.94 0 0 1 5.99-2.73m-.01 1.01c-.81 0-1.58.14-2.3.39.67.26 1.15.91 1.14 1.67 0 .76-.47 1.41-1.14 1.67.72.25 1.49.39 2.3.39 1.93 0 3.67-.79 4.93-2.06-1.26-1.27-3-2.06-4.93-2.06M27.64 15.31c2.39 0 4.53 1.06 5.99 2.73l.29.33-.29.33a7.94 7.94 0 0 1-5.99 2.73l-.455-.013a7.92 7.92 0 0 1-5.545-2.718l-.28-.33.29-.329a7.94 7.94 0 0 1 5.99-2.73m-.01 1.01c-.81 0-1.58.14-2.3.39.67.26 1.15.91 1.14 1.67 0 .76-.47 1.4-1.14 1.66.72.25 1.49.39 2.3.39 1.93 0 3.67-.79 4.93-2.06-1.26-1.27-3-2.06-4.93-2.06z"
        clipRule="evenodd"
      />
      <path
        fill="#1D2124"
        fillRule="evenodd"
        d="M21 0c11.598 0 21 9.402 21 21s-9.402 21-21 21S0 32.598 0 21 9.402 0 21 0m0 1C9.954 1 1 9.954 1 21s8.954 20 20 20 20-8.954 20-20S32.046 1 21 1"
        clipRule="evenodd"
      />
    </g>
    <defs>
      <clipPath id="clip0_10198_366">
        <path fill="#fff" d="M0 0h42v42H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SingleSizeIllustrationFeedbackDefaultNeutral;
